// @flow

import type {SearchRequest} from '../models/SearchRequest';
import SearchUrlParser from './SearchUrlParser';
import type {Options} from './SearchUrlParser';
import {toTitleCase} from '../utils';
import querystring from 'query-string';
import {
    SLASH_PARAMETERS,
    COLON_PARAMETERS,
    BOUNDING_BOX_REGEX
} from '../models/SearchUrl';

export default class VRBOSearchUrlParser extends SearchUrlParser {
    parse(url: string, options: Options): SearchRequest {
        const parts: string[] = this.getUrlParts(url);
        let pathname;
        let query;

        if (!this.isEmpty(parts[1])) {
            if (parts[1].includes('?')) {
                [pathname, query] = parts[1].split('?');
            } else {
                pathname = parts[1];
            }
        }

        return this.parseParams(pathname, query, options);
    }

    parseParams = (
        pathname?: string,
        query?: string,
        options: Options
    ): SearchRequest => {
        const searchRequestModel: SearchRequest = {};
        if (query) {
            let queryObject = this.normalizeSleeps(querystring.parse(query));
            this.parseQueryParams(searchRequestModel, options, queryObject);
        }

        if (pathname && this.isValidPathname(pathname)) {
            const segments: string[] = this.parsePathnameSegments(pathname);
            const clearedSegments = this.clearHAPathParameters(segments);

            if (!searchRequestModel.q && !searchRequestModel.regionId) {
                this.setQFromPathname(searchRequestModel, clearedSegments);
            }
            this.setLegacyRegionPath(searchRequestModel, clearedSegments);
        }

        return searchRequestModel;
    };

    clearHAPathParameters = (segments: string[]) => {
        return segments.reduce((cleared, segment, i) => {
            if (
                !(
                    this.isRegionPathParam(segment) ||
                    segment.match(BOUNDING_BOX_REGEX) ||
                    SLASH_PARAMETERS.includes(segment) ||
                    SLASH_PARAMETERS.includes(segments[i - 1]) ||
                    COLON_PARAMETERS.includes(segment.split(':'))
                )
            ) {
                cleared.push(segment);
            }

            return cleared;
        }, []);
    };

    setQFromPathname = (
        searchRequestModel: SearchRequest,
        segments: string[]
    ) => {
        if (segments && segments.length) {
            searchRequestModel.q = toTitleCase(
                segments[segments.length - 1].replace(/-/g, ' ')
            );
        }
    };

    normalizeSleeps = (query: Object) => {
        let sleepsKey = 'sleeps-';
        let sleepsKeys = Object.keys(query).filter((key) => {
            return key.indexOf(sleepsKey) === 0;
        });

        sleepsKeys.forEach((key) => delete query[key]);

        if (sleepsKeys.length > 0) {
            let sleeps = sleepsKeys[sleepsKeys.length - 1].split(sleepsKey)[1];
            return {...query, sleeps};
        }

        return query;
    };
}
